import React from 'react'
import { Cart } from '../../assets'
import { t } from '../../miscellaneous/language'

const ItemsAlreadyPickupStatus = ({updateStaticStatus}) => {
    return (
        <div className="after-order-card">
            <div className="after-order-status-container">
                <span className="after-order-title">{t.text.itemPickedUp.title}</span>
                <span className="after-order-desc">{t.text.itemPickedUp.desc}</span>
            </div>
            <div className="after-order-icon-container">
                <Cart id="cart-medium-icon" />
            </div>
        </div>
    )
}

export default ItemsAlreadyPickupStatus
